import { createRouter, createWebHistory } from 'vue-router';
import store from '../template-store';
import routes from './routes';
import { useLoginStore } from '../store/auth/LoginStore';

const router = new createRouter({
  // mode: 'history',
  history: createWebHistory(),
  routes,
  linkExactActiveClass: 'active',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.layout && to.meta.layout == 'auth') {
    store.commit('setLayout', 'auth');
  } else {
    store.commit('setLayout', 'app');
  }

  // const selectMenu = document
  //   .querySelector('#sidebar a[href="' + to.fullPath + '"]')
  //   .getAttribute('data-target');
  // console.log(selectMenu);
  // document.querySelector('#sidebar .menu .sub-menu-custom').setAttribute('aria-expanded', false);
  // document
  //   .querySelector('#sidebar .menu .sub-menu-custom.' + selectMenu)
  //   .setAttribute('aria-expanded', true);

  const loginStore = useLoginStore();
  const checkAuth = async () => {
    await loginStore.checkAuth();

    if (to.meta.requiredAuth && !loginStore.isAuthenticated) {
      // next({ name: 'Login' });
      top.location = '/login';
    } else if (to.meta.requiredUnauth && loginStore.isAuthenticated) {
      next({ name: 'Dashboard' });
    } else {
      next(true);
    }
  };
  checkAuth();
});

export default router;
